import CategoryContainer from "./CategoryContainer"
import React from 'react'

const CategoryCreate = () => {
  return (
    <div className='page-body'>
      <CategoryContainer />
    </div>
  )
}

export default CategoryCreate